import { useState, useCallback } from 'react';

const useMessageModal = () => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    message: '',
    type: 'success',
    autoClose: true,
    autoCloseDelay: 3000,
    showCloseButton: true
  });

  const showMessage = useCallback((message, type = 'success', options = {}) => {
    setModalState({
      isOpen: true,
      message,
      type,
      autoClose: options.autoClose !== undefined ? options.autoClose : true,
      autoCloseDelay: options.autoCloseDelay || 3000,
      showCloseButton: options.showCloseButton !== undefined ? options.showCloseButton : true
    });
  }, []);

  const showSuccess = useCallback((message, options = {}) => {
    showMessage(message, 'success', options);
  }, [showMessage]);

  const showError = useCallback((message, options = {}) => {
    showMessage(message, 'error', options);
  }, [showMessage]);

  const showWarning = useCallback((message, options = {}) => {
    showMessage(message, 'warning', options);
  }, [showMessage]);

  const showInfo = useCallback((message, options = {}) => {
    showMessage(message, 'info', options);
  }, [showMessage]);

  const closeModal = useCallback(() => {
    setModalState(prev => ({ ...prev, isOpen: false }));
  }, []);

  return {
    modalState,
    showMessage,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    closeModal
  };
};

export default useMessageModal; 